import React, { Fragment } from "react";
import { Title } from "rizzui/typography";
import cn from "../../lib/utils/class-name";
import { menuItems } from "./menuItems";
import { useLocation } from "react-router";

export function SidebarMenu() {
  const pathname = useLocation();

  return (
    <div className="mt-2 pb-3 3xl:mt-6">
      {menuItems.map((item, index) => {
        const isActive = pathname.pathname === (item?.href as string);
        const pathnameExistInDropdowns: any = false;
        return (
          <Fragment key={item.name + "-" + index}>
            {item?.href ? (
              <div
                className={cn(
                  isActive
                    ? "bg-[#F5F5F5] dark:bg-[#262626]"
                    : "transition-colors duration-200 hover:bg-[#F5F5F5] dark:hover:bg-[#262626]",
                  "font-[switzer] text-[14px] leading-[18.48px] font-[400]"
                )}
              >
                {" "}
                <a
                  href={item?.href}
                  className={cn(
                    "group relative mx-3 my-0.5 flex items-center justify-between rounded-md px-3 py-3 lg:my-1 2xl:mx-5 2xl:my-2",
                    isActive
                      ? " before:top-2/5 text-btn before:absolute before:-start-3 before:block before:h-4/5 before:w-1 before:rounded-ee-md before:rounded-se-md before:bg-btn 2xl:before:-start-5"
                      : "text-primary"
                  )}
                >
                  <div className="flex items-center truncate ">
                    {item?.icon && (
                      <span
                        className={cn(
                          "me-2 inline-flex size-5 items-center justify-center rounded-md [&>svg]:size-5",
                          isActive ? "text-btn" : "text-primary"
                        )}
                      >
                        {item?.icon}
                      </span>
                    )}
                    <span className="truncate">{item.name}</span>
                  </div>
                  {/* {item?.badge?.length ? (
                    <StatusBadge status={item?.badge} />
                  ) : null} */}
                </a>
              </div>
            ) : (
              <Title
                as="h6"
                className={cn(
                  "mb-2 truncate px-6 text-xs font-normal tracking-widest text-gray-500 2xl:px-8",
                  index !== 0 && "mt-6 3xl:mt-7"
                )}
              >
                {item.name}
              </Title>
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
